<template>
  <AppPanelShell
    storage-key="aradcore-support"
    brand-subtitle="پنل پشتیبانی"
    brand-icon="i-lucide-headset"
    :nav-items="navItems"
    :search-groups="searchGroups"
    :breadcrumbs="breadcrumbs"
    :tab-bar-items="tabBarItems"
  >
    <template #user-menu="{ collapsed }">
      <AdminUserMenu
        :collapsed="collapsed"
        settings-to="/support/settings"
      />
    </template>
    <template #navbar-actions>
      <UButton
        color="error"
        variant="outline"
        size="sm"
        icon="i-lucide-log-out"
        class="hidden shrink-0 whitespace-nowrap sm:inline-flex"
        @click="logout"
      >
        خروج
      </UButton>
    </template>
    <slot />
  </AppPanelShell>
</template>

<script setup lang="ts">
import AdminUserMenu from '~/components/admin/UserMenu.vue'

const { navItems, searchGroups, breadcrumbs } = useSupportNav()
const adminStore = useAdminStore()

const tabBarItems = [
  { label: 'نمای کلی', icon: 'i-lucide-layout-dashboard', to: '/support' },
  { label: 'تیکت‌ها', icon: 'i-lucide-life-buoy', to: '/support/tickets' },
  { label: 'مشتریان', icon: 'i-lucide-users', to: '/support/customers' },
  { label: 'تنظیمات', icon: 'i-lucide-settings', to: '/support/settings' },
]

async function logout() {
  await adminStore.logout()
  await navigateTo('/auth/login')
}
</script>
